import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pages/ai_form_builder/icon-customization.svg")